<template>
  <div
    v-if="meritFilteringAllowed"
    class="mx-1">
    <div class="dropdown">
      <div class="d-grid">
        <button
          class="btn btn-primary btn-sm dropdown-toggle"
          :class="mobile ? 'w-100' : ''"
          type="button"
          id="meritFilter"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          :disabled="loading">
          Viewing: {{meritFilter == 'merit' ? "Merit Supply Only" : "All Products"}}
        </button>
        <div
          class="dropdown-menu"
          id="meritDropdown"
          :class="{'w-100': fullWidthMenu}"
          aria-labelledby="meritFilter">
          <a
            class="dropdown-item"
            :class="{active: meritFilter == 'merit'}"
            href="javascript: void(0)"
            @click="setMeritFilter('merit')"
            :data-bs-dismiss="mobile ? 'offcanvas' : ''">
            Merit Supply Only
            <i
              v-if="meritFilter == 'merit'"
              class="ms-1 fa fa-check-circle"/>
          </a>
          <a
            class="dropdown-item"
            :class="{active: meritFilter == 'all'}"
            href="javascript: void(0)"
            @click="setMeritFilter('all')"
            :data-bs-dismiss="mobile ? 'offcanvas' : ''">
            All Products
            <i
              v-if="meritFilter == 'all'"
              class="ms-1 fa fa-check-circle"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed} from 'vue';
  import { useStore } from 'vuex';
  
  // Initialize
  const props = defineProps(['loading', 'mobile', 'fullWidthMenu'])
  const store = useStore()
  
  // Methods
  const setMeritFilter = (value)=>{
    store.dispatch('setMeritFilter', value)
  }

  // Computed
  const meritFilter = computed(()=>{
    return store.getters.meritSupply
  })

  // Check if product set has 'meritsuppl' zoned products
  const meritFilteringAllowed = computed(()=>{
    const results = store.getters.productResults
    let list = []
    if(results?.products?.length){
      results.products.forEach((p)=>{
        const zones = _.split(p.include_zones, ',')
        _.each(zones, z => {
          if(z.length) list.push(z)
        })
      })
      list = _.uniq(list)
      const show = list.includes('MERITSUPPL')
      return show
    }
    return false
  })

</script>